import { get, put } from 'services/client'

const fetchCountries = () => get('countries')

const setUserLocale = (userId, locale) =>
  put(`users/${userId}/locale`, { locale })

const fetchCPV = () => get('cpv')

const fetchDocuments = () => get('documents')

export { fetchCountries, setUserLocale, fetchCPV, fetchDocuments }
